// extracted by mini-css-extract-plugin
export var displayNone = "_nm-6";
export var imgContainer = "_nm-2";
export var overflowHidden = "_nm-3";
export var productInfoCardButtonContainer = "_nm-5";
export var productTitleText = "_nm-4";
export var rightArrow = "_nm-1";
export var rightArrowContainer = "_nm-0";